import React, { forwardRef } from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("");
  }

  return classes.join(" ");
};

export const Input = forwardRef(function (
  {
    field,
    touched,
    errors,
    label,
    isRequired = false,
    withFeedbackLabel = false,
    customFeedbackLabel,
    onChange,
    type = "text",
    value = "",
    disabled = false,
    placeholder = false,
    className = "",
    ...props
  },
  ref
) {
  const handleWheel = (event) => {
    event.currentTarget.blur(); // Remove focus to prevent scrolling
  };
  return (
    <div className="form-group">
      {label && <label className={isRequired ? "required" : ""}>{label}</label>}
      {props.subLabel && <p style={{ marginTop: '-3px', color: '#2578ffff', fontSize: 12 }} className={'text-small p-0 mb-0'}>{props.subLabel}</p>}

      <input
        ref={ref}
        type={type}
        value={value}
        disabled={disabled}
        onWheel={handleWheel}
        {...field}
        {...props}
        className={
          className != "" ? className : `${getFieldCSSClasses(touched, errors)}`
        }
        onChange={onChange}
        placeholder={placeholder ? placeholder : `Enter ${label}`}
      />
      {withFeedbackLabel && (touched || errors) && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          // label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </div>
  );
});
